import { Button, Collapse, Radio, Space } from "antd";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import xor from "lodash/xor";
import React, { useEffect, useMemo, useReducer, useState, useRef } from "react";
import { Constant, DownloadReport, Functions } from "../Common"; //Functions

import {
	_Filter_Items,
	_Filter_Types,
	_Filters_Handlers,
	FilterActions,
	SaveFilter,
	ShowSavedFilter
} from "./FiltersData";
import { getShopperProfileValues } from "../PolygonGenerator/DemographicPopulationDensity";
import { intersection, pull, uniq } from "lodash";
import cloneDeep from "lodash/cloneDeep";
import { havePermission } from "../../permissions";
import MARKER_PERMISSIONS from "../../permissions/Markers.json";
import { getMyFilters } from "../../Services/auth";
import { FilterContext } from "../Context";
import { ApplyFilters, PullShopFromValidations, PushShopToValidations } from "./FilterComponents";
import { TopLevelFilter } from "./FiltersData/CustomComponents";
import { getSocialMediaBehaviourValues } from "../PolygonGenerator/SocialMediaBehaviors";
// import SocioEconomicMenu from "./FilterComponents/Socio Economic Menu";
const { clearEmptyObjects, getBooleanVale, getTenantName } = Functions;
const { variables } = Constant;

const SelectedPanelColor = "#bae7ff";
const { Panel } = Collapse;
const { filteredShops } = variables;

const getInitialState = () => {
	const tenantFilter = getMyFilters();
	let sectionState = {};
	for (let { ApiTag, FilterType } of Object.values(tenantFilter ?? {})) {
		sectionState[ApiTag] = {
			FilterType
		};
	}
	sectionState[FilterActions.FilterType] = true;
	sectionState.tenant = { [FilterActions.FilterType]: true };
	return sectionState;
};

const reducer = (state, action) => {
	let _ApiTag = action?.value?._ApiTag;
	let _Child_ApiTag = action?.value?._Child_ApiTag;
	let _SectionApiTag = action?.value?._SectionApiTag;
	let { type } = action;
	let section = _SectionApiTag ? state[_SectionApiTag] : state;
	switch (type) {
		case FilterActions.Checkbox:
			let _Checkbox_State = [...(section[_ApiTag] ?? [])];
			_Checkbox_State.includes(_Child_ApiTag)
				? _Checkbox_State.splice(_Checkbox_State.indexOf(_Child_ApiTag), 1)
				: _Checkbox_State.push(_Child_ApiTag);
			return { ...state, [_SectionApiTag]: clearEmptyObjects({ ...section, [_ApiTag]: _Checkbox_State }) };
		case FilterActions.Radio:
			let _Radio_State = section[_ApiTag] ?? "";
			_Radio_State = _Radio_State === _Child_ApiTag ? "" : _Child_ApiTag;
			return {
				...state,
				[_SectionApiTag]: clearEmptyObjects({ ...section, [_ApiTag]: _Radio_State })
			};
		case FilterActions.Input:
			const {
				value: { value }
			} = action;
			return {
				...state,
				[_SectionApiTag]: clearEmptyObjects({
					...section,
					[_ApiTag]: clearEmptyObjects({ ...section[_ApiTag], [_Child_ApiTag]: value })
				})
			};
		case FilterActions.FilterType:
			if (state[FilterActions.FilterType] === action.value) return state;
			return {
				...state,
				[FilterActions.FilterType]: action.value
			};
		case FilterActions.Reset:
			return getInitialState(action.value);
		case FilterActions.SelectedAll:
			const _SelectedAll_State = section[_ApiTag] ?? [];
			let newState = uniq([...(section?.[_ApiTag] || []), ..._Child_ApiTag]);
			if (isEqual(intersection(_SelectedAll_State, _Child_ApiTag), _Child_ApiTag)) {
				newState = xor(_SelectedAll_State, _Child_ApiTag);
			} else if (_SelectedAll_State) {
				newState = xor(pull(_SelectedAll_State, ..._Child_ApiTag), _Child_ApiTag);
			}
			return {
				...state,

				[_SectionApiTag]: clearEmptyObjects({ ...section, [_ApiTag]: newState })
			};
		case FilterActions.TOP_LEVEL_FILTER:
			return {
				...state,
				[_SectionApiTag]: clearEmptyObjects({ ...section, [_ApiTag]: _Child_ApiTag })
			};
		case FilterActions.loadFilter:
			const { filters } = action.value;
			return {
				...filters
			};

		case FilterActions.Text:
			const {
				value: { value: textValue }
			} = action;
			return {
				...state,
				[_SectionApiTag]: clearEmptyObjects({
					...section,
					[_ApiTag]: textValue
				})
			};
		case FilterActions.SetFlag:
			const { _label, _flagValue } = action.value;

			if (_flagValue?.value) {
				return {
					...state,
					tenant: { ...state.tenant, [_label]: _flagValue }
				};
			}
			const tenantData = state.tenant;
			delete tenantData[_label];
			return {
				...state,
				tenant: tenantData
			};

		case "addSection":
			const { newSection } = action.value;

			return {
				...state,
				...newSection
				// [_SectionApiTag]: { ...state[_SectionApiTag], [_label]: _flagValue }
			};
		default:
			return state;
	}
};

const Filters = ({ loadingsData, _tenant, homeDispatch, children, resetShopsCounts, page = "analysis" }) => {
	const tenantFilter = useMemo(() => getMyFilters(page), []);

	let [state, dispatch] = useReducer(reducer, {}, () => {
		return getInitialState(_tenant, tenantFilter);
	});

	const initialState = useMemo(() => {
		let sectionState = {};

		for (let { ApiTag, FilterType, _Childrens } of Object.values(tenantFilter ?? {})) {
			sectionState[ApiTag] = {
				FilterType
			};
			for (const key of Object.keys(_Childrens)) {
				const { _ApiTag: chlidApiTag } = _Childrens[key];
				sectionState[ApiTag][chlidApiTag] = {};
			}
		}

		sectionState[FilterActions.FilterType] = true;
		sectionState.tenant = { [FilterActions.FilterType]: true };

		return sectionState;
	}, [_tenant, tenantFilter]);

	let [modelVisible, setModelVisible] = useState(false);
	let [drawerVisible, setDrawerVisible] = useState(false);
	let [, setCurrentFilter] = useState(null);

	useEffect(() => {
		localStorage.setItem("userFilters", JSON.stringify(state));
	}, [state]);
	const demographicFilterKeys = useMemo(() => getShopperProfileValues(structuredClone(state)), [state]);
	const SocialMediaBehaviorsKeys = useMemo(() => getSocialMediaBehaviourValues(structuredClone(state)), [state]);

	const prevDemographicFilterKeysRef = useRef(demographicFilterKeys);
	const prevSocialMediaBehaviorsKeysRef = useRef(SocialMediaBehaviorsKeys);

	useEffect(() => {
		// Only dispatch if the current value is different from the previous one.
		if (!isEqual(prevDemographicFilterKeysRef.current, demographicFilterKeys)) {
			homeDispatch({
				type: "setObject",
				actions: {
					set: {
						demographicFilterKeys
					}
				}
			});
			// Update the ref with the latest value.
			prevDemographicFilterKeysRef.current = demographicFilterKeys;
		}
	}, [demographicFilterKeys, homeDispatch]);

	useEffect(() => {
		// Only dispatch if the current value is different from the previous one.
		if (!isEqual(prevSocialMediaBehaviorsKeysRef.current, SocialMediaBehaviorsKeys)) {
			homeDispatch({
				type: "setObject",
				actions: {
					set: {
						SocialMediaBehaviorsKeys
					}
				}
			});
			// Update the ref with the latest value.
			prevSocialMediaBehaviorsKeysRef.current = SocialMediaBehaviorsKeys;
		}
	}, [SocialMediaBehaviorsKeys, homeDispatch]);

	// const { name } = useMemo(() => {
	// 	if (isEmpty(currentFilter)) return { disablePushToApp: true, name: "None", filterId: null };
	// 	const { filters, title, _id } = currentFilter;

	// 	return isEqual(state, filters)
	// 		? { disablePushToApp: false, name: title, filterId: _id }
	// 		: { disablePushToApp: true, name: "None", filterId: null };
	// }, [currentFilter, state]);
	return (
		<FilterContext.Provider value={{ state, dispatch }}>
			<div className="container-fluid">
				{/* 1st table  row  start */}
				<div
					className="row"
					style={{
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
						//width: "100%",
						display: "flex"
					}}
				>
					<div
						className="col-12 m-0 p-0"
						style={{
							//width: "fit-content",
							marginBottom: "4px"
							//marginTop: "15px"
						}}
					>
						{children?.[0]}
					</div>
				</div>
				{/* 1st table  row  end */}
				{/* 2nd row show stats start  */}
				<div className="row mt-3">
					<div className="col-12">
						<div className="d-flex flex-row justify-content-center">
							{havePermission(MARKER_PERMISSIONS.BUTTON_SHOP_STATS) && (
								<Button
									className="blueclr"
									disabled={getBooleanVale(loadingsData, `StatsData`, true)}
									onClick={() => {
										homeDispatch({
											type: "setObject",
											actions: {
												set: {
													modelVisible: true
												}
											}
										});
									}}
								>
									Show Stats
								</Button>
							)}
							{havePermission(MARKER_PERMISSIONS.BUTTON_CENSUS_SHOPS_REPORT_DONWLOAD) && (
								<DownloadReport clientFlag={false} Filters={cloneDeep(state)} />
							)}

							{havePermission(MARKER_PERMISSIONS.BUTTON_CLINET_SHOPS_REPORT_DONWLOAD) && (
								<DownloadReport clientFlag={true} tenant={_tenant} Filters={cloneDeep(state)} />
							)}

							{havePermission(MARKER_PERMISSIONS.BUTTON_CENSUS_SHOPS_REPORT_EMAIL) && (
								<DownloadReport
									clientFlag={false}
									tenant={_tenant}
									Filters={cloneDeep(state)}
									emailReport={true}
								/>
							)}
							{children?.[1]}
						</div>
					</div>
				</div>
				<div className="row my-3 bg-blue">
					<div className="col-12">
						<h4 className="mb-0">Filters</h4>
					</div>
				</div>

				<div className="row ">
					<div className="col-12 mb-2 px-0 hidden">
						{Array.isArray(tenantFilter) && tenantFilter.length > 0 && (
							<div className="4btn d-flex flex-row justify-content-center">
								<ApplyFilters />

								<Button
									className="blueclr"
									// disabled={!markerLoadingStatus || applyFilterLoading}
									onClick={() => {
										resetShopsCounts?.();
										if (!isEmpty(state)) {
											dispatch({
												type: FilterActions.Reset,
												value: _tenant
											});
											homeDispatch({
												type: "setObject",
												actions: {
													set: {
														[`tableData.${filteredShops}`]: 0,
														[`tableData.${getTenantName(_tenant)} Selected`]: 0
														// ["_markers"]: [],
														// ["tenant_markers"]: []
													}
												}
											});
											homeDispatch({
												type: "RESET"
											});
										}
									}}
								>
									Reset
								</Button>
								<Button
									className="blueclr "
									onClick={() => {
										setModelVisible(true);
									}}
								>
									Save Changes
								</Button>
								<Button
									className="blueclr"
									onClick={() => {
										setDrawerVisible(true);
									}}
								>
									Bookmarks
								</Button>
								{/* <SocioEconomicMenu _tenant={_tenant} /> */}
							</div>
						)}
					</div>
					<div className="btn d-flex flex-row justify-content-center">
						{havePermission(MARKER_PERMISSIONS.BUTTON_PUSH_TO_VALIDATION_APP) && <PushShopToValidations />}

						{havePermission(MARKER_PERMISSIONS.BUTTON_PULL_FROM_VALIDATION_APP) && (
							<PullShopFromValidations />
						)}
					</div>
				</div>
				{Array.isArray(tenantFilter) && tenantFilter.length > 0 && (
					<Collapse defaultActiveKey={"filters"} activeKey={"filters"} onChange={() => {}}>
						<Panel
							header={"Filters"}
							key={"filters"}
							extra={[
								<div className="row  mr-1">
									{tenantFilter && (
										<Radio.Group
											onChange={e => {
												dispatch({
													type: FilterActions.FilterType,
													value: e.target.value
												});

												// _Filters_Handlers[_Filter_Types.Radio]({
												// 	dispatch,
												// 	_SectionApiTag: "",
												// 	_ApiTag: FilterActions.FilterType,
												// 	_Child_ApiTag: e.target.value
												// })
											}}
											value={state[FilterActions.FilterType]}
										>
											<Space
												direction="horizontal"
												size="small"
												style={{ display: "flex" }}
												align="left"
											>
												<Radio value={true}>Intersection</Radio>
												<Radio value={false}>Union</Radio>
											</Space>
										</Radio.Group>
									)}
									{/* <h6>
										Current Selection: <span>"{name}"</span>
									</h6> */}
								</div>
							]}
						>
							<div className="row">
								<div className="col-12 ">
									<TopLevelFilter
										_tenant={_tenant}
										dispatch={dispatch}
										value={state[FilterActions.TOP_LEVEL_FILTER] || {}}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<Collapse defaultActiveKey={""} onChange={() => {}}>
										{tenantFilter?.map(
											({
												Label,
												_Childrens,
												Key,
												ApiTag: _SectionApiTag,
												_Show_FilterType,
												defaultActiveKey
											}) => {
												return (
													<Panel
														style={{
															"background-color":
																state?.[_SectionApiTag] &&
																Object.keys(state[_SectionApiTag]).length > 1
																	? SelectedPanelColor
																	: "#f0f0f0f0"
														}}
														extra={
															<>
																{_Show_FilterType && (
																	<>
																		<Radio.Group
																			onChange={e =>
																				_Filters_Handlers[_Filter_Types.Radio]({
																					dispatch,
																					_SectionApiTag,
																					_ApiTag: FilterActions.FilterType,
																					_Child_ApiTag: e.target.value
																				})
																			}
																			value={
																				state[_SectionApiTag][
																					FilterActions.FilterType
																				]
																			}
																		>
																			<Space
																				direction="horizontal"
																				size="small"
																				style={{ display: "flex" }}
																				align="left"
																			>
																				<Radio value={true}>Intersection</Radio>
																				<Radio value={false}>Union</Radio>
																			</Space>
																		</Radio.Group>
																	</>
																)}
															</>
														}
														header={Label}
														Key={Key}
													>
														{Object.values(_Childrens).map(
															({
																_Label,
																_ApiTag,
																_Type,
																_Childrens,
																_Other_Lable,
																_Other_ApiTag,
																_extra
															}) => {
																return (
																	_Filter_Items[_Type] &&
																	_Filter_Items[_Type]({
																		tenant: state["tenant"],
																		_Label,
																		_ApiTag,
																		_Childrens,
																		_SectionApiTag,
																		value: state?.[_SectionApiTag]?.[_ApiTag],
																		resursiveValue: state?.[_SectionApiTag],
																		_Other_Lable,
																		_Other_ApiTag,
																		defaultActiveKey,
																		dispatch,
																		_extra
																	})
																);
															}
														)}
													</Panel>
												);
											}
										)}
									</Collapse>
								</div>
							</div>
						</Panel>
					</Collapse>
				)}

				{/* collapse row div last end  */}
				{modelVisible && (
					<SaveFilter
						modelVisible={modelVisible}
						setModelVisible={setModelVisible}
						filter={state}
						setCurrentFilter={setCurrentFilter}
					/>
				)}
				{drawerVisible && (
					<ShowSavedFilter
						initialState={initialState}
						visible={drawerVisible}
						onClose={setDrawerVisible}
						dispatch={dispatch}
						currentFilter={state}
						setCurrentFilter={setCurrentFilter}
					/>
				)}
			</div>
		</FilterContext.Provider>
	);
};

export default Filters;
